import { connect, MapStateToProps } from 'react-redux';
import { Props } from './Pagination';
import { getPageSize } from '../publicSession/selectors';

export type StateProps = Pick<Props, 'pageSize'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  pageSize: getPageSize(state),
});

export default connect(mapStateToProps);
